export const crawlLabels = { decouverte: "Page d’entrée — découverte uniquement", collectee: "Collectée", inchangee: "Inchangée", ignoree: "Ignorée", non_visitee: "Non visitée", interrompue: "Traitement interrompu", erreur: "Erreur", present: "Document présent" };
export const indexLabels = { disponible: "Indexée", exclu: "Exclue du RAG", en_attente: "En attente", extraction: "Extraction", indexation: "Indexation", erreur: "Erreur RAG", supprime: "Document supprimé", remplace: "Version remplacée", inconnu: "État inconnu" };
export function matchesCrawlFilter(row, filter) {
  if (filter === "all") return true;
  if (filter === "errors") return row.status === "erreur" || row.index_status === "erreur";
  if (filter === "indexed") return row.index_status === "disponible";
  if (filter === "pending") return ["en_attente", "extraction", "indexation"].includes(row.index_status);
  if (filter === "non_visitee") return ["non_visitee", "interrompue"].includes(row.status);
  return row.status === filter;
}
export function crawlCsv(report) {
  const cell = (value) => {
    let text = String(value ?? "").replaceAll("\0", "");
    if (/^\s*[=+@-]/u.test(text)) text = "'" + text;
    return '"' + text.replaceAll('"', '""') + '"';
  };
  const header = ["URL demandée", "URL finale", "Titre", "Collecte", "Indexation RAG", "Motif", "Erreur collecte", "Erreur RAG", "Avertissement", "Version", "Segments", "Embeddings"];
  const rows = (report.rows || []).map((r) => [r.url, r.final_url, r.title, crawlLabels[r.status] || r.status,
    indexLabels[r.index_status] || r.index_status, r.reason || r.index_message, r.error, r.index_error,
    r.embedding_warning, r.document_version, r.chunks, r.embedding_model]);
  return "\ufeff" + [header, ...rows].map((r) => r.map(cell).join(";")).join("\r\n");
}
